<template>
  <div class="container">
    <div class="filter" :style="[filterStyle || {}]">
      <slot name="filter"></slot>
    </div>
    <div class="LaTable-body" :style="[bodyStyle || {}]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['bodyStyle', 'filterStyle']

}
</script>

<style lang="scss" scoped>
.container {
  flex: 1;
  height: -webkit-fill-available;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 71px 1fr;
}
.filter {
  height: 71px;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  padding-left: 27px;
  padding-right: 23px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}
.LaTable-body {
  flex:1;
  height: -webkit-fill-available;
  box-sizing: border-box;
  overflow-y: auto;
}
</style>
